const COOKIE_NAME = "clientAuth";
const COOKIE_EXPIRY_MINUTES = 60;

export function setCookie(name: string, value: string, minutes: number = COOKIE_EXPIRY_MINUTES): void {
  const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
  const cookieValue = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  document.cookie = cookieValue;
}

export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    // Refresh expiration when accessed
    const cookieValue = decodeURIComponent(parts.pop()?.split(";").shift() || '');
    setCookie(name, cookieValue, COOKIE_EXPIRY_MINUTES);
    return cookieValue;
  }
  return null;
}

export function deleteCookie(name: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}

export function getOrgNameFromInstanceUrl(url: string): string | null {
  try {
    const host = new URL(url).host;
    const parts = host.split('.');
    if (parts.length >= 2) {
      let orgName = parts.at(-2) === 'salesforce' ? parts[0] : parts.at(-2);
      return orgName || null;
    }
  } catch (e) {
    console.warn('Could not parse OrgName from instanceUrl', e);
  }
  return null;
}

export function clearAuthCookie(): void {
  deleteCookie(COOKIE_NAME);
}